import api from './api';
import {
  UnidadMedida,
  CreateUnidadMedidaRequest,
  UpdateUnidadMedidaRequest,
  UnidadMedidaFilters,
} from '../types/unidadesMedida';

const BASE_URL = '/unidades-medida';

export const unidadesMedidaAPI = {
  /**
   * Obtener todas las unidades de medida
   */
  getAll: async (filters?: UnidadMedidaFilters): Promise<UnidadMedida[]> => {
    const params = new URLSearchParams();

    if (filters?.activo !== undefined) {
      params.append('activo', filters.activo.toString());
    }

    if (filters?.tipo) {
      params.append('tipo', filters.tipo);
    }

    const url = params.toString() ? `${BASE_URL}?${params}` : BASE_URL;
    const response = await api.get<UnidadMedida[]>(url);
    return response.data;
  },

  /**
   * Obtener una unidad de medida por ID
   */
  getById: async (id: number): Promise<UnidadMedida> => {
    const response = await api.get<UnidadMedida>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Crear una nueva unidad de medida
   */
  create: async (data: CreateUnidadMedidaRequest): Promise<UnidadMedida> => {
    const response = await api.post<UnidadMedida>(BASE_URL, data);
    return response.data;
  },

  /**
   * Actualizar una unidad de medida existente
   */
  update: async (id: number, data: UpdateUnidadMedidaRequest): Promise<UnidadMedida> => {
    const response = await api.put<UnidadMedida>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  /**
   * Desactivar una unidad de medida (soft delete)
   */
  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Obtener solo las unidades activas
   */
  getActivas: async (): Promise<UnidadMedida[]> => {
    return unidadesMedidaAPI.getAll({ activo: true });
  },

  /**
   * Obtener unidades por tipo
   */
  getByTipo: async (tipo: 'peso' | 'volumen' | 'cantidad'): Promise<UnidadMedida[]> => {
    return unidadesMedidaAPI.getAll({ tipo, activo: true });
  },
};

export default unidadesMedidaAPI;
